import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Box,
  Button,
  Grid,
  CircularProgress,
  Tabs,
  Tab,
} from "@mui/material";
import { ModalBody, ModalFooter, ModalHeader } from "../CommonComponents/RightDrawer";
import { toastAlert } from "../../helpers/toastAlert";
import { getTaskDetail } from "../../services/taskService";
import { connect } from "react-redux";
import "./style.css";

import FolderIcon from "@mui/icons-material/Folder";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

import TaskCard from "../CommonComponents/TaskCard";
import TaskThread from "../CommonComponents/TaskThread";
import FollowupForm from "../CommonComponents/Map/TaskFollowup";
import { asEntityId, hasPermission } from "../../utils/commonutils";
import ModuleFollowups from "../CommonComponents/ModuleFollowups";
import AttachmentPanel from "../CommonComponents/AttachmentPanel";
import { submissionStatusLabel } from "../../utils/taskSubmissionDefaults";

class TaskView extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      data: {},
      tabValue: 0,
    };
  }

  getTaskDetail = async () => {
    try {
      this.setState({ loading: true });

      let tasks = await getTaskDetail(
        { taskId: this.props.taskId },
        this.props
      );

      if (tasks && tasks?.data) {
        this.setState({
          data: tasks.data,
          loading: false,
        });
      } else {
        toastAlert(tasks?.message || "Problem Fetching Records.", "error");
        this.setState({ loading: false });
      }
    } catch (error) {
      toastAlert("Please check Internet Connection.", "error");
      this.setState({ loading: false });
    }
  };

  componentDidMount() {
    this.getTaskDetail();
  }

  render() {
    const { data, loading, tabValue } = this.state;

    /* =========================
       Permission Based Tabs
    ========================== */
    const tabs = [];

    if (hasPermission("read_taskThread")) {
      tabs.push({
        key: "thread",
        label: "Task Thread",
        icon: <FolderIcon />,
        content: (
          <TaskThread
            threads={data?.taskThreads ?? []}
            customerId={asEntityId(data?.customerId)}
            thisEvt={this}
            
            props={this.props}
            taskId={data?._id}
            employeeId={asEntityId(data?.employeeId)}
          />
        ),
      });
    }

    if (hasPermission("read_followup")) {
      tabs.push({
        key: "followup",
        label: "Follow-up",
        icon: <AssignmentTurnedInIcon />,
        content: (
          <FollowupForm
            mode="view"
            followupData={data}
            props={this.props}
            onSubmit={this.getTaskDetail}
          />
        ),
      });
    }

    if (data?._id) {
      tabs.push({
        key: "module-followup",
        label: "Notes",
        icon: <AssignmentTurnedInIcon />,
        content: (
          <ModuleFollowups
            moduleName="task"
            recordId={data._id}
            customerId={asEntityId(data?.customerId)}
            props={this.props}
          />
        ),
      });
      tabs.push({
        key: "attachments",
        label: "Attachments",
        icon: <FolderIcon />,
        content: (
          <AttachmentPanel moduleName="task" recordId={data._id} customerId={asEntityId(data?.customerId)} />
        ),
      });
    }

    const handleChange = (event, newValue) => {
      this.setState({ tabValue: newValue });
    };

    return (
      <div className="right-drawer-stack">
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" flex="1 1 auto" p={4}>
            <CircularProgress style={{ color: "#5F5BA8" }} size={50} />
          </Box>
        ) : (
          <>
            {/* ================= Header ================= */}
            <ModalHeader toggle={this.props.handleTaskViewClose} kicker="Tasks">
              Task overview
            </ModalHeader>

            {/* ================= Body ================= */}
            <ModalBody>
              <Grid container spacing={2}>
                {/* Left Card */}
                <Grid item xs={12} lg={5}>
                  <TaskCard
                    name={data?.name}
                    description={data?.description}
                    status={data?.status}
                    priority={data?.priority}
                    deadline={data?.deadline}
                    customer={data?.customerId?.companyName}
                    employee={data?.employeeId?.name}
                    taskType={data?.taskType}
                    customerSubmissionStatus={
                      data?.customerSubmissionStatus
                        ? submissionStatusLabel(data.customerSubmissionStatus)
                        : null
                    }
                  />
                </Grid>

                {/* Right Tabs */}
                <Grid item xs={12} lg={7}>
                  {tabs.length > 0 && (
                    <>
                      <Tabs
                        value={tabValue}
                        onChange={handleChange}
                        textColor="inherit"
                        indicatorColor="secondary"
                        sx={{
                          "& .MuiTabs-indicator": {
                            height: "4px",
                            backgroundColor: "var(--thm-color)",
                            borderRadius: "5px",
                          },
                          "& .MuiTab-root": {
                            textTransform: "none",
                            fontWeight: "bold",
                            padding: "12px 24px",
                          },
                          "& .Mui-selected": {
                            color: "var(--thm-color) !important",
                          },
                        }}
                      >
                        {tabs.map((tab) => (
                          <Tab
                            key={tab.key}
                            icon={tab.icon}
                            iconPosition="start"
                            label={tab.label}
                          />
                        ))}
                      </Tabs>

                      {/* ================= Tab Content ================= */}
                      <Box sx={{ paddingTop: 2 }}>
                        {tabs[tabValue]?.content}
                      </Box>
                    </>
                  )}
                </Grid>
              </Grid>
            </ModalBody>

            {/* ================= Footer ================= */}
            <ModalFooter>
              <Button
                className="btn btn-border small-text-color"
                onClick={this.props.handleTaskViewClose}
              >
                Close
              </Button>
            </ModalFooter>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.authReducer,
});

export default withRouter(connect(mapStateToProps)(TaskView));
